import { useMemo } from 'react'
import { type PropertyValue } from 'api/clients/PropertyClient'
import { isURL } from 'validator'
import Styles from '../PropertyValue.module.scss'

interface Props {
  propertyValue?: PropertyValue
}

const Link = ({ propertyValue }: Props) => {
  const isValidUrl = useMemo(() => {
    return propertyValue?.value && isURL(propertyValue?.value)
  }, [propertyValue?.value])

  const actualLink = useMemo(() => {
    return isURL(propertyValue?.value ?? '', { require_protocol: true })
      ? propertyValue?.value
      : `https://${propertyValue?.value}`
  }, [propertyValue?.value])

  return isValidUrl ? (
    <a
      className={Styles.linkValue}
      href={actualLink}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      {propertyValue?.value}
    </a>
  ) : (
    <span>{propertyValue?.value}</span>
  )
}

export default Link
